// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Widget/Punctuality/KpiDirection" (18906:121122). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const widgetPunctualityKpidirectionContract = {
    component: 'Widget/Punctuality/KpiDirection',
    nodeId: '18906:121122',
    section: 'Punctuality · Components',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        {
            component: 'SeverityItem',
            variants: [
                'variant=critical, size=small',
                'variant=success, size=small',
                'variant=warning, size=small',
            ],
        },
        { component: 'Widget/Punctuality/DirectionLabel', variants: [] },
        { component: 'Widget/Stat/CountLabel', variants: ['size=inline'] },
        { component: 'Widget/Stat/SeverityBar', variants: ['status=success', 'status=warning'] },
        {
            component: 'Widget/Stat/TrendMeasure',
            variants: [
                'size=inline, trend=critical, labelPosition=inline, emphasis=default',
                'size=inline, trend=success, labelPosition=inline, emphasis=default',
                'size=small, trend=critical, labelPosition=inline, emphasis=default',
                'size=small, trend=success, labelPosition=inline, emphasis=default',
            ],
        },
    ],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [] as readonly ContractDisagreement[],
    textStyleIds: ['S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,'],
    props: {
        direction: { kind: 'enum', values: ['departures', 'arrivals'] },
        layout: { kind: 'enum', values: ['stacked', 'wide'] },
        noPrediction: { kind: 'boolean' },
    },
    variants: {
        'direction=arrivals, layout=stacked': {
            container: 'gap-s w-[19.5rem] items-start',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'today': 'gap-2xs items-start',
                'Widget/Punctuality/DirectionLabel': 'items-center',
                'Widget/Stat/TrendMeasure': 'items-baseline',
                'windows': 'gap-2xs items-start',
                'Last 60 min': 'gap-xs items-center',
                'Widget/Stat/TrendMeasure 2': 'h-[1.25rem] items-baseline',
                'Next 3h': 'gap-xs items-center',
                'Widget/Stat/TrendMeasure 3': 'h-[1.25rem] items-baseline',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [
                {
                    component: 'SeverityItem',
                    variants: ['variant=success, size=small', 'variant=warning, size=small'],
                },
                { component: 'Widget/Punctuality/DirectionLabel', variants: [] },
                { component: 'Widget/Stat/SeverityBar', variants: ['status=warning'] },
                {
                    component: 'Widget/Stat/TrendMeasure',
                    variants: [
                        'size=inline, trend=critical, labelPosition=inline, emphasis=default',
                        'size=inline, trend=success, labelPosition=inline, emphasis=default',
                        'size=small, trend=success, labelPosition=inline, emphasis=default',
                    ],
                },
            ],
        },
        'direction=arrivals, layout=wide': {
            container: 'gap-2xl w-[25.4375rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'values': 'gap-s items-start',
                'today': 'gap-2xs items-start',
                'Widget/Punctuality/DirectionLabel': 'items-center',
                'Widget/Stat/TrendMeasure': 'items-baseline',
                'windows': 'gap-2xs items-start',
                'Last 60 min': 'gap-xs items-center',
                'Widget/Stat/TrendMeasure 2': 'h-[1.25rem] items-baseline',
                'Next 3h': 'gap-xs items-center',
                'Widget/Stat/TrendMeasure 3': 'h-[1.25rem] items-baseline',
                'delayed': 'gap-2xs items-start',
                'title': 'text-content-muted text-left',
                '16–29 min': 'items-baseline',
                '30–59 min': 'items-baseline',
                '60+ min': 'items-baseline',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                title: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'SeverityItem',
                    variants: ['variant=success, size=small', 'variant=warning, size=small'],
                },
                { component: 'Widget/Punctuality/DirectionLabel', variants: [] },
                { component: 'Widget/Stat/CountLabel', variants: ['size=inline'] },
                { component: 'Widget/Stat/SeverityBar', variants: ['status=warning'] },
                {
                    component: 'Widget/Stat/TrendMeasure',
                    variants: [
                        'size=inline, trend=critical, labelPosition=inline, emphasis=default',
                        'size=inline, trend=success, labelPosition=inline, emphasis=default',
                        'size=small, trend=success, labelPosition=inline, emphasis=default',
                    ],
                },
            ],
        },
        'direction=departures, layout=stacked': {
            container: 'gap-s w-[19.5rem] items-start',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'today': 'gap-2xs items-start',
                'Widget/Punctuality/DirectionLabel': 'items-center',
                'Widget/Stat/TrendMeasure': 'items-baseline',
                'windows': 'gap-2xs items-start',
                'Last 60 min': 'gap-xs items-center',
                'Widget/Stat/TrendMeasure 2': 'h-[1.25rem] items-baseline',
                'Next 3h': 'gap-xs items-center',
                'Widget/Stat/TrendMeasure 3': 'h-[1.25rem] items-baseline',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [
                {
                    component: 'SeverityItem',
                    variants: ['variant=critical, size=small', 'variant=warning, size=small'],
                },
                { component: 'Widget/Punctuality/DirectionLabel', variants: [] },
                { component: 'Widget/Stat/SeverityBar', variants: ['status=success'] },
                {
                    component: 'Widget/Stat/TrendMeasure',
                    variants: [
                        'size=inline, trend=critical, labelPosition=inline, emphasis=default',
                        'size=small, trend=critical, labelPosition=inline, emphasis=default',
                    ],
                },
            ],
        },
        'direction=departures, layout=wide': {
            container: 'gap-2xl w-[25.4375rem] items-start',
            label: 'text-content-muted text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'values': 'gap-s items-start',
                'today': 'gap-2xs items-start',
                'Widget/Punctuality/DirectionLabel': 'items-center',
                'Widget/Stat/TrendMeasure': 'items-baseline',
                'windows': 'gap-2xs items-start',
                'Last 60 min': 'gap-xs items-center',
                'Widget/Stat/TrendMeasure 2': 'h-[1.25rem] items-baseline',
                'Next 3h': 'gap-xs items-center',
                'Widget/Stat/TrendMeasure 3': 'h-[1.25rem] items-baseline',
                'delayed': 'gap-2xs items-start',
                'title': 'text-content-muted text-left',
                '16–29 min': 'items-baseline',
                '30–59 min': 'items-baseline',
                '60+ min': 'items-baseline',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                title: 'S:b3f9781c3f24a2a84844e4dd3a95088b476f48d2,',
            } as Record<string, string>,
            composes: [
                {
                    component: 'SeverityItem',
                    variants: ['variant=critical, size=small', 'variant=warning, size=small'],
                },
                { component: 'Widget/Punctuality/DirectionLabel', variants: [] },
                { component: 'Widget/Stat/CountLabel', variants: ['size=inline'] },
                { component: 'Widget/Stat/SeverityBar', variants: ['status=success'] },
                {
                    component: 'Widget/Stat/TrendMeasure',
                    variants: [
                        'size=inline, trend=critical, labelPosition=inline, emphasis=default',
                        'size=small, trend=critical, labelPosition=inline, emphasis=default',
                    ],
                },
            ],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
